<!--
@create date 2024-5-11
@desc m100.phomemo.com
-->
<template>
  <div class="m100-guide-div">
    <div class="topContainerDivEx">
      <h1>M150 Label Maker Support</h1>
      <div class="productDiv">
        <div class="leftDiv">
          <img
            src="https://oss.qu-in.top/printerFiles/phomemo/M150/M150.png"
            style="margin: 10px auto; width: 350px"
          />
        </div>
        <div class="rightDiv">
          <p>
            In addition to the printer support and repair resources on this
            page, also see the following:
          </p>
          <div class="linkDiv">
            <div style="margin-bottom: 2px">
              <a style="color: black; font-weight: bold"
                >M150 Instruction Manual：</a
              >
            </div>
            <div class="linkList">
              <a
                href="https://oss.qu-in.top/afterSale/overseas/M150/M150 User Guide_EN_241115.pdf"
                target="_blank"
              >
                ENGLISH</a
              >
              |
              <a
                href="https://oss.qu-in.top/afterSale/overseas/M150/M150 ユーザーガイド_JA_241115.pdf"
                target="_blank"
                >日本語</a
              >
              |
              <a
                href="https://oss.qu-in.top/afterSale/overseas/M150/M150 Benutzerhandbuch_DE_241115.pdf"
                target="_blank"
                >DEUTSCH</a
              >
              |
              <a
                href="https://oss.qu-in.top/afterSale/overseas/M150/M150 Mode d'emploi_FR_241115.pdf"
                target="_blank"
                >Français</a
              >
              |
              <a
                href="https://oss.qu-in.top/afterSale/overseas/M150/M150 Guida per l'utente_IT_241115.pdf"
                target="_blank"
                >Italiano</a
              >
              |
              <a
                href="https://oss.qu-in.top/afterSale/overseas/M150/M150 Guía de usuario_ES_241115.pdf"
                target="_blank"
                >Español</a
              >
            </div>
          </div>
          <p>
            Product registration is no longer necessary. Retain proof of
            purchase for warranty confirmation.
          </p>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/faqsIcon.png?v=1663316214"
          style="margin: 0"
        />
        <div class="textContainer">Label Roll Installation</div>
      </div>
      <div class="videosDivE">
        <div class="rightDiv" style="float: left; padding-top: 0%">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 90%"
            poster="https://oss.qu-in.top/printerFiles/phomemo/M150/M150安装纸卷-封面.jpg"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/M150/M150安装纸卷.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/driversIcon.png?v=1663240538"
          style="margin: 0"
        />
        <div class="textContainer">App for Android / iOS</div>
      </div>
      <div class="videosDivE videoFlex">
        <div class="leftDiv" style="padding-top: 2%; margin-left: 45px">
          <img
            src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/Print_Master.png?v=1679455148"
            style="
              display: block;
              margin: 0 auto;
              margin-bottom: 10px;
              margin-top: 26px;
              width: 100px;
            "
          />
          <a class="a-link">Print Master</a>
        </div>
        <div class="videoList">
          <div class="item">
            <video
              controls
              webkit-playsinline="true"
              class="video"
              poster="https://oss.qu-in.top/printerFiles/phomemo/M100/IOS下载-封面.jpg"
              style="width: 90%"
            >
              <source
                src="https://oss.qu-in.top/printerFiles/phomemo/M150/IOS下载.mp4"
                type="video/mp4"
              />
              您的浏览器不支持 HTML5 video 标签。
            </video>
            <a
              class="downloadBtn"
              href="https://apps.apple.com/cn/app/%E5%B0%8F%E6%A0%87%E6%89%93%E5%8D%B0/id1467113436"
              target="_blank"
            >
              <img
                src="https://oss.qu-in.top/printerFiles/phomemo/M150/APPStoreIcon.png"
              />
            </a>
          </div>
          <div class="item">
            <video
              controls
              webkit-playsinline="true"
              class="video"
              poster="https://oss.qu-in.top/printerFiles/phomemo/M100/Android下载-封面.jpg"
              style="width: 90%"
            >
              <source
                src="https://oss.qu-in.top/printerFiles/phomemo/M150/Android下载.mp4"
                type="video/mp4"
              />
              您的浏览器不支持 HTML5 video 标签。
            </video>
            <a
              class="downloadBtn"
              href="https://play.google.com/store/apps/details?id=com.project.aimotech.printmaster"
              target="_blank"
            >
              <img
                src="https://oss.qu-in.top/printerFiles/phomemo/M150/GooglePlayAppDownload.png"
              />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/driversIcon.png?v=1663240538"
          style="margin: 0"
        />
        <div class="textContainer">Drivers for PC / Mac</div>
      </div>
      <div class="driverItemsContainer">
        <div class="driverDownloadDiv">
          <div class="leftDiv">
            <img
              src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/Windows_c4bdbd8d-36be-4370-9649-d8d811361bed.png?v=1679455147"
              style="
                display: block;
                margin: 0 auto;
                margin-bottom: 10px;
                margin-top: 26px;
                width: 90px;
              "
            />
            <a class="a-link">Windows</a>
          </div>
          <div class="centerDiv">
            <a
              class="downloadBtn"
              href="https://oss.qu-in.com/soft/QY_Printer_Driver_WIN.zip"
              target="_blank"
            >
              <img
                src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/WindowsBtn.png?v=1679469921"
                style="width: 330px; position: relative; top: 0px"
              />
            </a>
          </div>
          <!-- <div class="rightDiv">
          <video controls webkit-playsinline="true" class="video"
            poster="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/1_4a89a2ad-3495-4359-946c-7e033e2423c2.jpg?v=1683182600">
            <source src="https://oa.aimotech.cn/phomemo/pm246s/m221_1_windows_setupguide.mp4" type="video/mp4" />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div> -->
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
          v-show="isMobile()"
        />
        <div class="driverDownloadDiv">
          <div class="leftDiv">
            <img
              src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/2235.png?v=1644832141"
              style="display: block; margin: 10px auto; width: 105px"
            />
            <a class="a-link">macOS</a>
          </div>
          <div class="centerDiv">
            <a
              class="downloadBtn"
              href="https://oss.qu-in.com/soft/QY_Printer_Driver_MAC.zip"
              target="_blank"
            >
              <img
                src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/MacBtn.png?v=1679469921"
                style="width: 330px; position: relative; top: 0px"
              />
            </a>
          </div>
          <!-- <div class="rightDiv">
          <video controls webkit-playsinline="true" class="video"
            poster="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/2_9f8df457-093e-484b-897f-7787cac3fe27.jpg?v=1683182585">
            <source src="https://oa.aimotech.cn/phomemo/pm246s/m221_2_mac_setupguide_a.mp4" type="video/mp4" />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div> -->
        </div>
      </div>
    </div>

    <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/driversIcon.png?v=1663240538"
          style="margin: 0"
        />
        <div class="textContainer">Software for PC / Mac</div>
      </div>
      <div class="driverItemsContainer">
        <div class="driverDownloadDiv">
          <div class="leftDiv" style="padding-top: 8px">
            <img
              src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/Labelife.png?v=1679475208"
              style="
                display: block;
                margin: 0 auto;
                margin-bottom: 10px;
                margin-top: 26px;
                width: 100px;
              "
            />
            <a class="a-link">Labelife</a>
          </div>
          <div class="centerDiv">
            <a
              class="downloadBtn"
              href="https://www.labelife.net/#/download"
              target="_blank"
            >
              <img
                src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/LabelifeBtn.png?v=1679469921"
                style="width: 330px; position: relative; top: 0px"
              />
            </a>
          </div>
          <div class="rightDiv">
            <video
              controls
              webkit-playsinline="true"
              class="video"
              poster="https://oss.qu-in.top/printerFiles/phomemo/M100/labelifeVideoPoster.png"
            >
              <source
                src="https://oss.qu-in.top/printerFiles/phomemo/M100/Labelife安装&USB连接-英文.mp4"
                type="video/mp4"
              />
              您的浏览器不支持 HTML5 video 标签。
            </video>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="howToVideosDiv faqBarDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/faqsIcon.png?v=1663316214"
          style="margin: 0"
        />
        <div class="textContainer" title="Frequently Asked Questions">FAQ</div>
      </div>
      <div class="faq-content-area" style="margin-top: 30px">
        <div class="faq-container">
          <div class="faq-item" v-for="(item, index) in faqDataApp">
            <div class="faq-title" @click="clickQuestion2(item, index)">
              <span v-text="item.title"></span>
              <img
                src="https://cdn.shopify.com/s/files/1/0595/1940/2172/files/f10e2c4832c0faf086185700b226c940.png?v=1646813187"
                class="downArrow"
                v-show="activeQuestion2.index === index"
              />
              <img
                src="https://cdn.shopify.com/s/files/1/0595/1940/2172/files/a016b412f93b877a827866a90379da25.png?v=1646813168"
                class="downArrow"
                v-show="activeQuestion2.index !== index"
              />
            </div>
            <div class="faq-scroll-area">
              <div
                class="faq-content"
                v-show="activeQuestion2.index === index"
                v-for="child in item.details"
              >
                <div class="content-title" v-html="child.theme"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <hr
      style="color: rgba(51, 61, 71, 0.3); margin-top: 50px; margin-bottom: 6px"
    />
    <!--   联系方式 -->
    <div class="customServiceDiv">
      <div class="everyRow">
        Tel：+1 855 957 5321(US ONLY)<br /><span style="padding-left: 42px"
          >+1 833 940 3818</span
        >
      </div>
      <div class="everyRow">
        WhatsApp：+86 15338193665<br /><span style="padding-left: 101px"
          >+86 13928088284</span
        >
      </div>
      <div class="everyRow">
        Email：
        <a href="mailto:support@phomemo.com">support@phomemo.com</a>
      </div>
      <div class="everyRow">Service time：Mon-Fri 9AM-5PM (EST)</div>
    </div>
    <WechatMask />
  </div>
</template>

<script>
import WechatMask from "@/components/WechatMask.vue";

// const faqDataApp = [
//   {
//     title:
//       "1. Why is my M221 not recognized by the computer after successful driver installation?",
//     details: [
//       {
//         theme:
//           "You need to connect M221 to your computer with cable first, and then install the driver.",
//       },
//     ],
//   },
// ];
const isMobile = () => {
  // 返回true为移动端，否则为pc端
  if (!window.navigator) return true;
  const flag = window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag ? true : false;
};
export default {
  name: "M150",
  components: { WechatMask },
  props: {},
  data() {
    return {
      // faqDataApp,
      activeQuestion2: {},
      isMobile,
      window,
    };
  },
  mounted() {},
  methods: {
    clickQuestion2(item = {}, index) {
      const { activeQuestion2 } = this;
      if (
        activeQuestion2.index === undefined ||
        activeQuestion2.index !== index
      ) {
        this.activeQuestion2 = { ...item, index };
      } else this.activeQuestion2 = {};
    },
  },
};
</script>

<style lang="less" src="./m100.less" />



// WEBPACK FOOTER //
// src/view/guides/m150.vue